import React from 'react'

// Components
import ProjectSlider from 'components/flex/Posts/ProjectSlider'
import PostsBlog from 'components/flex/Posts/PostsBlog'
import PostsProjects from 'components/flex/Posts/PostsProjects'
import PostPackages from 'components/flex/Posts/PostPackages'
import PostProcess from 'components/flex/Posts/PostProcess'
import PostsProducts from 'components/flex/Posts/PostsProducts'
import PostsVacatures from 'components/flex/Posts/PostsVacatures'

interface PostsShellProps {
  fields: any
  location?: any
}

interface PostsProps {
  [key: string]: any
}

function PostsShell({ fields, location = {} }: PostsShellProps) {
  const posts: PostsProps = {
    projects_highlighted: ProjectSlider,
    blogs: PostsBlog,
    projects: PostsProjects,
    packages: PostPackages,
    process: PostProcess,
    products: PostsProducts,
    vacancies: PostsVacatures,
  }

  if (!fields.styletype || !posts[fields.styletype]) {
    return null
  }

  const Component = posts[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default PostsShell
